/**
 * Phase 14c — operator profile (display name editor).
 *
 * Backs `PATCH /me/operator/profile`. The operator's display name is
 * a User-row field; this is the only mutable operator-self field today.
 */
import { z } from 'zod';
export const OperatorProfileResponseSchema = z.object({
    userId: z.string().uuid(),
    email: z.string().email(),
    displayName: z.string().nullable(),
    /** Whether the account already has a password. Magic-link-only operators
     *  have none — the UI then offers "Set password" (no current-password field)
     *  instead of "Change password". */
    hasPassword: z.boolean(),
});
export const OperatorProfilePatchRequestSchema = z.object({
    /** Required, ≥1 char after trim. Display name shown in the admin header
     *  and used by the audit-event renderer. */
    displayName: z.string().trim().min(1).max(100),
});
//# sourceMappingURL=profile.schema.js.map